import BaseClient from "./BaseClient";

export default class CreditAllocationServiceClient extends BaseClient {
    constructor(billingDate = null, tenantId: string) {
        super(billingDate, tenantId, true, "ams");
    }

    public async getPaymentAllocations(accountId: string, transactionId: string) {

        const response = await this.get(`/api/proxy/ams/credit-allocation-service/account/${accountId}/transaction/${transactionId}`);

        return await this.handleResponse(response);
    }
}

export const useCreditAllocationService = (billingDate = null, tenantId: string): CreditAllocationServiceClient => {
    return new CreditAllocationServiceClient(billingDate, tenantId);
};